const controllerPath = document.querySelector('cart-drawer')?.dataset.controllerUrl;
const moduleUrl = new URL(controllerPath || './cart-drawer-controller.js', import.meta.url);
if (!controllerPath) moduleUrl.search = new URL(import.meta.url).search;
const cartRoot = () => window.Shopify?.routes?.root || '/';

let controllerPromise;
let deferredApi;
let deliveryPromise;

const loadDeliveryInstructions = () => {
  if (!deliveryPromise) {
    const url = new URL('./cake-delivery-instructions.js', import.meta.url);
    url.search = new URL(import.meta.url).search;
    deliveryPromise = import(url.href);
  }
  return deliveryPromise;
};

const loadController = () => {
  if (!controllerPromise) {
    controllerPromise = Promise.resolve().then(() => {
      if (window.AngesCart === deferredApi) delete window.AngesCart;
      return import(moduleUrl.href);
    });
  }
  return controllerPromise;
};

const callController = (method, args) => loadController().then(() => {
  const api = window.AngesCart;
  if (!api || api === deferredApi || typeof api[method] !== 'function') {
    throw new Error('Basket controller unavailable.');
  }
  return api[method](...args);
});

deferredApi = {
  renderSections(...args) {
    return callController('renderSections', args).catch(() => {});
  },
  refresh(...args) {
    return callController('refresh', args);
  },
  open(...args) {
    loadDeliveryInstructions().catch(() => {});
    return callController('open', args).catch(() => {});
  }
};

window.AngesCart ||= deferredApi;

document.addEventListener('click', (event) => {
  if (event.target.closest?.('[data-cart-open]')) loadDeliveryInstructions().catch(() => {});
}, { capture: true, passive: true });

document.addEventListener('click', async (event) => {
  const opener = event.target.closest?.('[data-cart-open]');
  if (!opener || customElements.get('cart-drawer')) return;
  event.preventDefault();

  try {
    await Promise.all([loadController(), loadDeliveryInstructions()]);
    if (!window.AngesCart?.refresh) throw new Error('Basket controller unavailable.');
    await window.AngesCart.refresh(true);
  } catch (_) {
    window.location.assign(opener.href || `${cartRoot()}cart`);
  }
}, true);

const hydrateCartPageProperties = async () => {
  const cartPage = document.querySelector('[data-cart-page]');
  if (!cartPage || cartPage.dataset.propertiesHydrated === 'true') return;

  try {
    const response = await fetch(`${cartRoot()}cart.js`, {
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) return;

    const cart = await response.json();
    const cartItems = Array.isArray(cart.items) ? cart.items : [];
    let hydratedAny = false;

    cartPage.querySelectorAll('[data-cart-item-key]').forEach((line) => {
      const item = cartItems.find((candidate) => candidate.key === line.dataset.cartItemKey);
      if (!item?.properties) return;

      const properties = Object.entries(item.properties).filter(([name, value]) => {
        return name && !name.startsWith('_') && value != null && String(value).trim() !== '';
      });
      if (!properties.length) return;

      const content = line.querySelector('.cart-item__content');
      if (!content) return;

      let panel = line.querySelector('.cart-item__personalisation');
      if (!panel) {
        panel = document.createElement('div');
        panel.className = 'cart-item__personalisation';
        const heading = document.createElement('h3');
        heading.textContent = 'Cake details';
        panel.appendChild(heading);
        const purchase = content.querySelector('.cart-item__purchase');
        if (purchase) content.insertBefore(panel, purchase);
        else content.appendChild(panel);
      }

      let list = panel.querySelector('.cart-item__properties');
      if (!list) {
        list = document.createElement('dl');
        list.className = 'cart-item__properties';
        panel.appendChild(list);
      }
      list.replaceChildren();

      properties.forEach(([name, value]) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const detail = document.createElement('dd');
        term.textContent = name;

        const textValue = String(value);
        if (textValue.includes('/uploads/')) {
          const link = document.createElement('a');
          link.href = textValue;
          link.target = '_blank';
          link.rel = 'noopener';
          link.textContent = textValue.split('/').pop() || 'Uploaded file';
          detail.appendChild(link);
        } else {
          detail.textContent = textValue;
        }

        row.append(term, detail);
        list.appendChild(row);
      });

      hydratedAny = true;
    });

    if (hydratedAny) cartPage.dataset.propertiesHydrated = 'true';
  } catch (_) {
    // Keep the server-rendered basket usable if the JSON endpoint is unavailable.
  }
};

const initialiseCartPage = () => {
  hydrateCartPageProperties();
  if (document.querySelector('[data-cart-page]')) loadDeliveryInstructions().catch(() => {});
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialiseCartPage, { once: true });
} else {
  initialiseCartPage();
}

document.addEventListener('shopify:section:load', () => {
  const cartPage = document.querySelector('[data-cart-page]');
  if (cartPage) {
    delete cartPage.dataset.propertiesHydrated;
    hydrateCartPageProperties();
    loadDeliveryInstructions().catch(() => {});
  }
});
